/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

const CRMLeadListHeader = ({
  userInfo,
  reloadLeadList = () => {},
  downloadAsExcel = () => {},
  enetredNumberForSelect = "",
  setEnetredNumberForSelect = () => {},
  setSelectedNumberValidationMessage = () => {},
  recordSelectionHandler = () => {},
  bulkUpdateHandler = () => {},
  selectedNumberValidationMessage = "",
  leadsDataList = [],
  followingLeadsCount = 0,
  opportunitiesTotalCount = 0,
  totalNotesCount = 0,
  totalConversationCount = 0,
  jsonFilterQuery = [],
  selectedLeadIds = [],
  showAllLeadsHandler = () => {},
  setShowDeleteOffcanvas = () => {},
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: t("CRM"), link: "/admin/crm/lead/list" },
    { title: t("Leads") },
  ];

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <ul className="d-flex align-items-center gap-2">
            <li role="presentation">
              Leads :{" "}
              <span className="text-primary">{leadsDataList.length}</span>
            </li>

            <li role="presentation">
              <Link
                to="#"
                className="d-flex align-items-center justify-content-center dropdown-toggle fw-bold"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="material-symbols-outlined icon-fill fw-bold">
                  more_vert
                </span>
              </Link>

              <ul className="dropdown-menu dropdown-menu-end p-3 bg-white border-0 rounded-3 shadow">
                <li className="mb-2" role="presentation">
                  Opportunities :{" "}
                  <span className="text-primary">
                    {opportunitiesTotalCount}
                  </span>
                </li>

                <li className="mb-2" role="presentation">
                  Following :{" "}
                  <span className="text-primary">{followingLeadsCount}</span>
                </li>

                <li className="mb-2" role="presentation">
                  Notes :{" "}
                  <span className="text-primary">{totalNotesCount}</span>
                </li>

                <li className="" role="presentation">
                  Conversations :{" "}
                  <span className="text-primary">{totalConversationCount}</span>
                </li>
              </ul>
            </li>
          </ul>
          <div className="d-flex gap-2 align-items-center">
            <div className="checkbox_select_input_box">
              <input
                className={`form-control shadow-none py-2 ${
                  selectedNumberValidationMessage === ""
                    ? "border border-gray-300"
                    : "is-invalid"
                }`}
                placeholder={t("Enter page")}
                type="number"
                min={0}
                value={enetredNumberForSelect}
                onChange={(e) => {
                  setEnetredNumberForSelect(e.target.value);
                  setSelectedNumberValidationMessage("");
                }}
              />
            </div>

            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm"
              onClick={recordSelectionHandler}
            >
              <span className="fw-semibold small">{t("Select")}</span>
            </button>
          </div>

          {/* <!-- ========== Start refresh Section ========== --> */}
          <Link
            onClick={reloadLeadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          {/* <!-- ========== End refresh Section ========== --> */}

          {/* <!-- ========== Start view redirect Section ========== --> */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("List View")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to={`/admin/crm/lead/list`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    list
                  </span>
                  <span className="d-block">{t("List View")}</span>
                </Link>
              </li>
              {/* <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-1"
                  to={`/admin/crm/lead/kanban`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    view_kanban
                  </span>
                  <span className="d-block">{t("Kanban View")}</span>
                </Link>
              </li> */}
              {/* dnd kit kanban */}
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to={`/admin/crm/lead/kanbankit`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    view_kanban
                  </span>
                  <span className="d-block">{t("Kanban View")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to={`/admin/crm/lead/dashboard`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    grid_view
                  </span>
                  <span className="d-block">{t("Dashboard View")}</span>
                </Link>
              </li>
            </ul>
          </div>
          {/* <!-- ========== End view redirect Section ========== --> */}

          {/* <!-- ========== Start Action Dropdown Section ========== --> */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu bg-white fs-sm border-0 rounded-3 shadow" style={{ minWidth: '220px' }}>
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  onClick={showAllLeadsHandler}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    visibility
                  </span>
                  <span className="d-block">{t("Show all leads")}</span>
                </Link>
              </li>
              {userInfo.role.slug === "ADMIN" ||
              userInfo.role.slug === "SUPER_ADMIN" ? (
                <li>
                  <Link
                    to="#"
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#crmLeadAllowFieldsBySector"
                    aria-controls="crmLeadAllowFieldsBySector"
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      checklist
                    </span>
                    <span className="d-block">{t("Manage Allowed Fields")}</span>
                  </Link>
                </li>
              ) : null}
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedLeadIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedLeadIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedLeadIds.length === 0 ? undefined : "#addLabelModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">{t("Manage Label")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedLeadIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedLeadIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedLeadIds.length === 0 ? undefined : "#addFollowers"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    person
                  </span>
                  <span className="d-block">{t("Add Followers")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedLeadIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle="modal"
                  data-bs-target="#addCompanyModal"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    apartment
                  </span>
                  <span className="d-block">{t("Assign Company")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedLeadIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedLeadIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedLeadIds.length === 0 ? undefined : "#addToList"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    list
                  </span>
                  <span className="d-block">{t("Add To List")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedLeadIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  onClick={() => {
                    if (selectedLeadIds.length > 0) {
                      bulkUpdateHandler();
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    progress_activity
                  </span>
                  <span className="d-block">{t("Update Rank")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedLeadIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedLeadIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedLeadIds.length === 0
                      ? undefined
                      : "#createAlertModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    alarm
                  </span>
                  <span className="d-block">{t("Create alert")}</span>
                </Link>
              </li>
              <hr className="dropdown-divider" />
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedLeadIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedLeadIds.length === 0 ? undefined : "offcanvas"
                  }
                  data-bs-target={
                    selectedLeadIds.length === 0
                      ? undefined
                      : "#offcanvasNewMail"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    email
                  </span>
                  <span className="d-block">{t("Send Mail")}</span>
                </Link>
              </li>
              {userInfo.role.slug === "ADMIN" ||
              userInfo.role.slug === "SUPER_ADMIN" ? (
                <li>
                  <Link
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedLeadIds.length === 0 ? "disabled text-muted" : ""
                    }`}
                    to="#"
                    data-bs-toggle={
                      selectedLeadIds.length === 0 ? undefined : "modal"
                    }
                    data-bs-target={
                      selectedLeadIds.length === 0 ? undefined : "#veriFyEmail"
                    }
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      email
                    </span>
                    <span className="d-block">{t("Verify Emails")}</span>
                  </Link>
                </li>
              ) : null}
              <hr className="dropdown-divider" />
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="#"
                  onClick={downloadAsExcel}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    download
                  </span>
                  <span className="d-block">{t("Download as XLS")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#csvUploadModal"
                >
                  <span className="d-block material-symbols-outlined icon-md">
                    upload
                  </span>
                  <span className="d-block">{t("CSV/XLS Upload")}</span>
                </Link>
              </li>

              <hr className="dropdown-divider" />
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="#"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#aiRecommendationPopup"
                  aria-controls="aiRecommendationPopup"
                >
                  {/* Use Material icon: "psychology_alt" for AI Recommendation */}
                  <span className="d-block material-symbols-outlined icon-sm">
                    psychology_alt
                  </span>
                  <span className="d-block">{t("AI Recommend")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedLeadIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedLeadIds.length === 0 ? undefined : "offcanvas"
                  }
                  data-bs-target={
                    selectedLeadIds.length === 0
                      ? undefined
                      : "#offcanvasScheduleAutomation"
                  }
                  aria-controls="offcanvasScheduleAutomation"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    schedule
                  </span>
                  <span className="d-block">{t("Schedule Automation")}</span>
                </Link>
              </li>

              <hr className="dropdown-divider" />
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedLeadIds.length === 0
                      ? "disabled text-muted"
                      : "text-danger"
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedLeadIds.length === 0 ? undefined : "offcanvas"
                  }
                  data-bs-target={
                    selectedLeadIds.length === 0
                      ? undefined
                      : "#leadDisablePopup"
                  }
                  onClick={() => setShowDeleteOffcanvas(true)}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>
          {/* <!-- ========== End Action Dropdown Section ========== --> */}

          <Link
            to="#"
            className={`btn ${
              jsonFilterQuery.length > 0
                ? "btn-outline-primary"
                : "btn-light border"
            } d-flex align-items-center px-4 py-2 rounded-3 shadow-sm`}
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#leadAdvFilter"
            aria-controls="leadAdvFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
            <span
              className={
                jsonFilterQuery.length > 0
                  ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                  : "d-none"
              }
              style={{ minWidth: 22, minHeight: 22 }}
            >
              {jsonFilterQuery.length}
            </span>
          </Link>

          {/* <!-- ========== Start Add New Section ========== --> */}
          <Link
            to="#"
            className="btn btn-outline-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#addMultipleLeads"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Quick Add")}</span>
          </Link>

          <Link
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
            to={`/admin/crm/lead/save`}
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Add")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default CRMLeadListHeader;
